import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { fill: true },
  },
});

type SubjectReviewIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function SubjectReviewIcon({
  className,
  pathClassName = "fill-gray-800",
  ...props
}: SubjectReviewIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M22 16.653c0 .251-.05.5-.15.73a2 2 0 01-.41.62c-.181.172-.391.31-.62.41a1.939 1.939 0 01-.74.14 15.22 15.22 0 00-3.37.32 9.312 9.312 0 00-3.71 1.27V5.233c1.091-.52 2.26-.857 3.46-1a17.43 17.43 0 013.71-.33 1.92 1.92 0 011.3.61c.33.352.513.818.51 1.3l.02 10.84zM11 5.233v14.91a9.248 9.248 0 00-3.65-1.27 16.174 16.174 0 00-3.43-.32 1.87 1.87 0 01-.74-.14 2.16 2.16 0 01-.62-.41 1.81 1.81 0 01-.41-.62 1.83 1.83 0 01-.15-.73v-10.9a1.9 1.9 0 011.78-1.89 16.999 16.999 0 013.79.33A10.68 10.68 0 0111 5.233z"
        className={pathClassName}
      />
    </Svg>
  );
}

export default SubjectReviewIcon;
